<template>
  <div class="marketplace">
    <CabecalhoPrincipal
      :termo="termo"
      :recurso="recurso"
      @atualizar:termo="definirTermo"
      @atualizar:recurso="definirRecurso"
    />

    <main>
      <DestaqueInicial :cidade="CIDADE" />

      <CarrosselDeCategorias
        :categorias="segmentos"
        :selecionadas="segmentosSelecionados"
        @alternar="alternarSegmento"
      />

      <ListaDoCatalogo
        :itens="itensVisiveis"
        :recurso="recurso"
        :carregando="carregando"
        :mensagem-de-erro="mensagemDeErro"
        :possui-filtros-ativos="possuiFiltrosAtivos"
        :categorias-de-produto="categoriasDeProduto"
        :categoria-selecionada="categoria"
        :pagina="pagina"
        :paginas-conhecidas="paginasConhecidas"
        @limpar="limparFiltros"
        @selecionar-categoria="definirCategoria"
        @ir-para-pagina="irParaPagina"
      />
    </main>

    <RodapePrincipal />

    <AvisoDeConteudoAdulto
      :aberto="Boolean(segmentoAguardandoAviso)"
      @confirmar="confirmarMaioridade"
      @cancelar="segmentoAguardandoAviso = null"
    />
  </div>
</template>

<script setup>
  import '@/assets/css/marketplace.css';

  import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue';
  import { useStore } from 'vuex';

  import CabecalhoPrincipal from '@/components/marketplace/CabecalhoPrincipal.vue';
  import DestaqueInicial from '@/components/marketplace/DestaqueInicial.vue';
  import CarrosselDeCategorias from '@/components/marketplace/CarrosselDeCategorias.vue';
  import ListaDoCatalogo from '@/components/marketplace/ListaDoCatalogo.vue';
  import RodapePrincipal from '@/components/marketplace/RodapePrincipal.vue';
  import AvisoDeConteudoAdulto from '@/components/marketplace/AvisoDeConteudoAdulto.vue';

  const ATRASO_DA_BUSCA = 300;

  /* A plataforma atende uma unica cidade; exibida no cabecalho e no destaque. */
  const CIDADE = 'São Bento, PB';

  const store = useStore();

  const recurso = computed(() => store.state.catalogo.recurso);
  const termo = computed(() => store.state.catalogo.termo);
  const segmentosSelecionados = computed(() => store.state.catalogo.segmentosSelecionados);
  const categoria = computed(() => store.state.catalogo.categoria);
  const segmentos = computed(() => store.state.catalogo.segmentos);
  const carregando = computed(() => store.state.catalogo.carregando);
  const pagina = computed(() => store.state.catalogo.pagina);
  const paginasConhecidas = computed(() => store.state.catalogo.paginasConhecidas);
  const mensagemDeErro = computed(() => store.state.catalogo.mensagemDeErro);
  const itensVisiveis = computed(() => store.getters['catalogo/itensVisiveis']);
  const categoriasDeProduto = computed(() => store.getters['catalogo/categoriasDeProduto']);
  const possuiFiltrosAtivos = computed(() => store.getters['catalogo/possuiFiltrosAtivos']);

  let temporizador = null;

  const segmentoAguardandoAviso = ref(null);

  function definirTermo(valor) {
    store.commit('catalogo/definirTermo', valor);
  }

  function definirRecurso(valor) {
    store.commit('catalogo/definirRecurso', valor);
  }

  /*
   * Segmento adulto so entra no filtro depois do aviso, como a home anterior
   * fazia antes de levar para a listagem.
   */
  function alternarSegmento(id) {
    const segmento = segmentos.value.find((atual) => atual.id === id);
    const precisaAvisar = segmento
      && segmento.adulto
      && !store.state.catalogo.maioridadeConfirmada
      && !segmentosSelecionados.value.includes(id);

    if (precisaAvisar) {
      segmentoAguardandoAviso.value = id;
      return;
    }

    store.commit('catalogo/alternarSegmento', id);
  }

  function confirmarMaioridade() {
    store.commit('catalogo/confirmarMaioridade');
    store.commit('catalogo/alternarSegmento', segmentoAguardandoAviso.value);
    segmentoAguardandoAviso.value = null;
  }

  /* Refino sobre o resultado ja carregado: nao dispara busca nova. */
  function definirCategoria(valor) {
    store.commit('catalogo/definirCategoria', valor);
  }

  function limparFiltros() {
    store.commit('catalogo/limparFiltros');
  }

  /* Ao trocar de pagina a lista e substituida: leva o usuario ao topo dela. */
  async function irParaPagina(numero) {
    await store.dispatch('catalogo/IR_PARA_PAGINA', numero);

    const listagem = document.getElementById('lojas');

    if (listagem) listagem.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  watch([termo, recurso, segmentosSelecionados], (atual, anterior) => {
    clearTimeout(temporizador);

    /* Só a digitação espera; trocar recurso ou segmento busca na hora. */
    const trocouFiltro = atual.slice(1).some((valor, indice) => valor !== anterior[indice + 1]);

    temporizador = setTimeout(() => store.dispatch('catalogo/BUSCAR'), trocouFiltro ? 0 : ATRASO_DA_BUSCA);
  });

  onBeforeMount(() => store.dispatch('catalogo/INICIALIZAR'));

  onBeforeUnmount(() => clearTimeout(temporizador));
</script>
